import React from "react";
import Modal from "../../Modal";
import { useLogout } from "../../../hooks/useLogout/useLogout";
import { PENDING_AUTH_FROM_KEY } from "../../../hooks/useNavigateToDeviSubscribe";
import { getPath } from "../../../store/directories/selectors";
import { TranslationObject } from "../../../models/translationModal";

interface DeviCustomerLogoutModalProps {
    visible: boolean;
    onClose: () => void;
    entities?: TranslationObject;
}

const DEFAULT_TITLE = "Оформить подписку";
const DEFAULT_MESSAGE =
    "Если вы хотите получить доступ к деви постам вам необходимо выйти из аккаунта заказчика";
const DEFAULT_LOGOUT = "Выйти";
const DEFAULT_STAY = "Остаться";

const DeviCustomerLogoutModal: React.FC<DeviCustomerLogoutModalProps> = ({
    visible,
    onClose,
    entities,
}) => {
    const logout = useLogout();

    const handleLogout = () => {
        sessionStorage.setItem(PENDING_AUTH_FROM_KEY, "devi_subscribe");
        const pathLang = getPath()[0] || "el";
        void logout(`/${pathLang}/specialist/auth`);
        onClose();
    };

    const title =
        entities?.devi_customer_modal_title?.value ?? DEFAULT_TITLE;
    const description =
        entities?.devi_customer_modal_description?.value ?? DEFAULT_MESSAGE;
    const logoutLabel =
        entities?.devi_customer_modal_btn_leave?.value ?? DEFAULT_LOGOUT;
    const stayLabel =
        entities?.devi_customer_modal_btn_stay?.value ?? DEFAULT_STAY;

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            title={title}
            description={description}
        >
            <div className="modal__content-buttons">
                <button
                    className="btn btn--transparent"
                    type="button"
                    onClick={onClose}
                >
                    {stayLabel}
                </button>
                <button
                    className="btn modal__content-button btn--bg-green"
                    type="button"
                    onClick={handleLogout}
                >
                    {logoutLabel}
                </button>
            </div>
        </Modal>
    );
};

export default DeviCustomerLogoutModal;
